import axios, { AxiosError } from "axios"
import { handleError } from "../Helpers/ErrorHandler"
import { ContactUsModel } from "../Models/ContactUsModel";
import { MTB_PART_PICKER_API } from "../constants";


export const saveContactUsAPI = async (first_name: string, last_name: string, message: string, email: string) => {
    try {
        const data = await axios.post<ContactUsModel>(MTB_PART_PICKER_API + "/ContactUs", {
            first_name: first_name,
            last_name: last_name,
            message: message,
            email: email
        })

        return data;
    } catch (error) {
        handleError(error)
    }
};
